import { RX } from '../../constants/rx';
import { ADOBE_CONSTANTS } from '../../../../shared/js/constants';
import OrgUserLanguageSelector from '../../../../home/js/account/orgUserLanguageSelector';

const { flex } = window;
const {
    React,
    ReactAddons: { PropTypes },
    Moment
} = flex.lib;

const { loader } = flex.components;
const { adobe } = flex.tracking;

import LandingModal from './LandingModal';
import LandingMessage from './LandingMessage';


class Landing extends React.Component {
    static propTypes = {
        landing: PropTypes.shape({
            imageSrc: PropTypes.string,
            isModalOpened: PropTypes.bool
        }),
        appContext: PropTypes.object.isRequired
    };

    static defaultProps = {
        landing: {
            imageSrc: '',
            isModalOpened: false
        }
    };

    componentDidMount() {
        const { orgId, code } = this.props.appContext.app;

        flex.trigger(RX.LANDING.GET_IMAGE_URL, orgId, code);
        flex.trigger(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES, orgId, code);

        adobe.sendPageView({ signature: ADOBE_CONSTANTS.FIREBALL_SIGNATURE });
    }

    onLoginClick = () => {
        adobe.sendCustomEvent({
            customClickName: 'landing:login',
            signature: ADOBE_CONSTANTS.FIREBALL_SIGNATURE
        });

        flex.redirect('/sso');
    };

    render() {
        const { appContext, landing } = this.props;

        if (
            flex.isBusy(RX.LANDING.GET_IMAGE_URL) ||
            flex.isBusy(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES)
        ) {
            return loader;
        }

        const loginButtonLabel = flex.text('UX_LOGIN_ACT_LOGIN');
        const poweredByLabel = flex.text('UX_LOGIN_ACT_POWEREDBY', 'Powered by Manheim');

        const year = Moment().year();
        const orgSummary = appContext.app.org.summary;

        const {
            imageSrc,
            isModalOpened,
            footerTemplate = {},
            modalTemplate = {},
            messageTemplate = {}
        } = landing;

        const { content: footerContent } = footerTemplate;
        const { content: modalContent } = modalTemplate;
        const { content: messageContent } = messageTemplate;

        return (
          <div className="landing">
            {isModalOpened && <LandingModal content={modalContent} />}
            <header className="page-header landing__header">
              <div className="container top-container">
                <a className="landing__logo logo" role="logo" />
                <div className="landing__login-btn-container">
                  <OrgUserLanguageSelector />
                  <button
                    className="btn landing__login-btn"
                    onClick={this.onLoginClick}
                  >
                    {loginButtonLabel}
                  </button>
                </div>
              </div>
            </header>
            {messageContent && <LandingMessage content={messageContent} />}
            <div className="container landing__image-container">
              <img className="landing__image" decoding="async" src={imageSrc} />
            </div>
            <footer className="container landing__footer">
              Copyright &copy; {year} {orgSummary} All Rights Reserved. |{" "}
              {poweredByLabel}
              {footerContent && (
                <div
                  className="landing__footer-content"
                  dangerouslySetInnerHTML={{ __html: footerContent }}
                />
              )}
            </footer>
          </div>
        );
    }
}

export default Landing;
